import WithBordersDndList from 'components/WithBordersDndList/WithBordersDndList';

export default WithBordersDndList;
